<div>
    <div class="text-right">
        <button type="button" class="btn btn-primary" (click)="add()" data-toggle="modal"
            data-target="#myModal_skill">Add</button>

    </div>
    <table *ngIf='table.length' class="table table-striped table-responsive-md btn-table table-bordered text-dark">
        <thead>
            <tr>
                <th>Skill Name</th>
                <th>Version</th>
                <th>Last Used</th>
                <th>Experience(Yrs.)</th>
                <th>Months</th>
                <th>Operation</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor='let item of table;let i=index' [hidden]='check(item)'>
                <td>{{item.SKILLNAME}}</td>
                <td>{{item.VERSION}}</td>
                <td>{{item.LASTUSED}}</td>
                <td>{{item.EXPERIANCE}}</td>
                <td>{{item.MONTHS}}</td>
                <td class=" text-center"><input type="image" src="./../../../assets/images/sprites/edit.svg"
                        class="edit_icon text-center" (click)="edit(item,i)"  data-toggle="modal"  data-target="#myModal_skill" > </td>
            </tr>
        </tbody>
    </table>
    <p class="text-center" *ngIf='!table.length'>No Records</p>
</div>

<div class="modal" id="myModal_skill" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog ">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 *ngIf="!isEdit" class="modal-title"> Add Skill</h4>
                <h4 *ngIf="isEdit" class="modal-title"> Edit Skill</h4>
                <button type="button" (click)="close()" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <form class="well form-horizontal" [formGroup]="myForm" (ngSubmit)="onSubmit(myForm)">
                    <fieldset>
                        <div class="form-group row">
                            <label class="col-md-4 control-label">Skill Name <span class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group">
                                    <input formControlName='SkillName' type="text"
                                        class="form-control form-control-sm shadow-sm rounded-lg">

                                </div>
                                <div *ngIf="myForm.get('SkillName').touched">
                                    <span class="text-danger" *ngIf="myForm.get('SkillName').hasError('required')">
                                        This field is required.
                                    </span>

                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-4 control-label"> Version <span
                                    class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group">
                                    <input type="text" formControlName='Version'
                                        class="form-control form-control-sm shadow-sm rounded-lg">
                                      
                                </div>
                                <div *ngIf="myForm.get('Version').touched">
                                    <span class="text-danger" *ngIf="myForm.get('Version').hasError('required')">
                                        This field is required.
                                    </span>

                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-4 control-label">Last Used <span
                                    class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group">
                                    <input type="number" min="1" formControlName='LastUsed'
                                        class="form-control form-control-sm shadow-sm rounded-lg">
                                      
                                    
                                </div>
                                <div *ngIf="myForm.get('LastUsed').touched">
                                    <span class="text-danger" *ngIf="myForm.get('LastUsed').hasError('required')">
                                        This field is required.
                                    </span>

                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-4 control-label">Experience(Yrs.) <span
                                    class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group">
                                    <input type="number" min="1" formControlName='Experience'
                                        class="form-control form-control-sm shadow-sm rounded-lg">
                                      
                                </div>
                                <div *ngIf="myForm.get('Experience').touched">
                                    <span class="text-danger" *ngIf="myForm.get('Experience').hasError('required')">
                                        This field is required.
                                    </span>

                                </div>
                            </div>
                        </div>
                       
                        <div class="form-group row">
                            <label class="col-md-4 control-label line_2 rem_1">
                                Months <span class="text-danger">*</span></label>
                            <div class="col-md-8 inputGroupContainer">
                                <div class="input-group">
                                    <input type="number" min='1' placeholder="" class="form-control"
                                        formControlName="Months">
                                </div>
                                <div *ngIf="myForm.get('Months').touched">
                                    <span class="text-danger" *ngIf="myForm.get('Months').hasError('required')">
                                        This field is required.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" *ngIf="!isEdit" class="btn btn-success" (click)="onSubmit(myForm)"
                    [disabled]="myForm.invalid">Save</button>
                <button type="button" *ngIf="isEdit" class="btn btn-success" (click)="onSubmit(myForm)"
                    [disabled]="myForm.invalid">Update</button>
                <button type="button" class="btn btn-danger" id="md_close_skill" (click)="close()"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>